module.exports = __webpack_public_path__ + "img/1399_sprites_liga_española.991ddb03.png";